<template>
    <v-list-item v-if="item.version === 2" link :to="item.route.path">
        <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title>
                {{ item.title }}
                <v-chip v-if="item.beta" x-small outlined label :color="item.beta_color">
                    {{item.beta_tag}}
                </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.AIpowered">
                <v-chip small outlined pill color="info" link>
                    <span class="ai">
                        Claudia
                    </span>
                    <v-icon small class="ai">
                        mdi-creation
                    </v-icon>
                </v-chip>
            </v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
    <!-- Duplicado temporal para modulos en vue 3 -->
    <v-list-item v-else :prepend-icon="item.icon" :title="item.title" :href="`${v3Url}${item.route.path}`">
        <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title>
                {{ item.title }}
                <v-chip v-if="item.beta" x-small outlined label :color="item.beta_color">
                    {{item.beta_tag}}
                </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.AIpowered">
                <v-chip small outlined pill color="info" link>
                    <span class="ai">
                        Claudia
                    </span>
                    <v-icon small class="ai">
                        mdi-creation
                    </v-icon>
                </v-chip>
            </v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
const v3Url = process.env.VUE_APP_V3_URL
export default {
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            v3Url
        }
    }
}
</script>

<style>
.ai {
    animation: rainbow 4s linear infinite;
    background-image: linear-gradient(90deg, #00e6e6, #0059ff, #00e6e6, #0059ff);
    background-size: 300% 100%;
    -webkit-background-clip: text !important;
    background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    font-weight: bolder;
}

@keyframes rainbow {
    0% {
        background-position: 100% 0%;
    }

    100% {
        background-position: 0% 0%;
    }
}

.v-list-item-title {
    font-weight: 500;
}
</style>